export default __webpack_public_path__ + "static/blog-preview-3-d0e8136008a74da7281cacc541e03420.png";